"use strict";

require("./_two-images");